<template>
  <LayoutDefault />
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { CHECK_AUTH, AUTH_LOGOUT } from "@/store/actions/auth"
import { USER_ME_REQUEST } from "@/store/actions/user"
import ApiService from "@/utils/api.service"
import axios from "axios"
import LayoutDefault from "./components/LayoutDefault"
import JwtService from "@/utils/jwt.service"

export default {
  name: "App",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Themis application",
    // all titles will be injected into this template
  },
  components: { LayoutDefault },
  data: () => ({
    default: "/dashboard",
    refreshSubscribers: [],
    isRefreshing: false,
    items: [
      { icon: "mdi-brain", title: "home.title", path: "/" },
      {
        icon: "mdi-palette-swatch-outline",
        title: "feedback.title",
        path: "/feedbacks",
      },
    ],
    mini: false,
    showDrawer: true,
    drawerWidth: 256,
    scrollSettings: {
      maxScrollbarLength: 160,
    },

    //
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    computeLogo() {
      return "/img/pcv.jpg"
    },
    computeMenu() {
      return this.items
    },
    computeHeight() {
      return {
        height: this.height || "",
      }
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.USER_ME_REQUEST()
    }
  },
  methods: {
    onRefreshed(token) {
      this.refreshSubscribers.map((cb) => cb(token))
    },
    subscribeTokenRefresh(cb) {
      this.refreshSubscribers.push(cb)
    },
    processError(message, field) {
      const name = this.$t(`errors.${message}`, { field: field })
      this.$toast.error(`${name}`)
    },
    ...mapActions("auth", [CHECK_AUTH, AUTH_LOGOUT]),
    ...mapActions("user", [USER_ME_REQUEST]),

    handleDrawerCollapse() {
      this.mini = !this.mini
    },
    toggleDrawer() {
      this.showDrawer = !this.showDrawer
    },
  },
  created: function () {
    ApiService.setHeader()

    const self = this
    axios.interceptors.response.use(
      (response) => {
        return response
      },
      (err) => {
        const originalRequest = err.config
        /*if (err?.config?.url && err.config.url.includes('/login')) {
            return Promise.reject(err)
          }*/
        console.log("Interception")
        const status = err.response ? err.response.status : null
        if (status === 401 && !originalRequest._retry) {
          originalRequest._retry = true
          if (!self.isRefreshing) {
            self.isRefreshing = true
            if (!JwtService.getRefreshToken()) {
              this.$toast.error(self.$t("errors.token_expired"))
            }
            return self.CHECK_AUTH().then(
              () => {
                originalRequest.headers.Authorization =
                  "Bearer " + JwtService.getToken()
                self.isRefreshing = false
                self.onRefreshed(JwtService.getToken())
                return axios.request(originalRequest)
              },
              (errorRefresh) => {
                console.log(errorRefresh)
                self.processError(err.response.data.message)
              }
            )
          }
          const retryOrigReq = new Promise((resolve) => {
            self.subscribeTokenRefresh((token) => {
              // replace the expired token and retry
              originalRequest.headers.Authorization = "Bearer " + token
              resolve(axios(originalRequest))
            })
          })
          return retryOrigReq
        } else if ([422, 400, 403].includes(status)) {
          const { data } = err.response
          const { messages } = data
          console.log(data)
          if (messages !== undefined) {
            self.processError("required_field", Object.keys(messages[0])[0])
          } else {
            self.processError(err.response.data.message)
          }

          return Promise.reject(err)
        }
        if (!err.response && !axios.isCancel(err)) {
          // network error
          self.$toast.error("Error: Network Error")
          // self.showError('Error: Network Error')
        }
        return Promise.reject(err)
      }
    )
  },
}
</script>
<style lang="scss">
.application {
  font-family: "Roboto";
  font-size: 8px;
}
</style>
